import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dipinDanshuang'
})
export class DipinDanshuangPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    // 单双形态
    let form: string;
    let b1;
    let b2;

    switch (args) {
      case 'qianer':
        b1 = Number(value[0]);
        b2 = Number(value[1]);
        form = this.calculation_form_handler(b1, b2);
        break;
      case 'houer':
        b1 = Number(value[1]);
        b2 = Number(value[2]);
        form = this.calculation_form_handler(b1, b2);
        break;
      default: break;
    }
    return form;
  }

  private calculation_form_handler(b1, b2): string {
    let str: string;
    let s1: string;
    let s2: string;

    if (b1 % 2 === 0) {
      s1 = '双';
    } else {
      s1 = '单';
    }

    if (b2 % 2 === 0) {
      s2 = '双';
    } else {
      s2 = '单';
    }

    str = `${s1}${s2}`;
    return str;
  }

}
